import React, { useState, useEffect } from "react";
import axiosInstance from "../AxiosInstance";
import SidebarLayout from "../SidebarLayout";
import { Container, Button } from "@mui/material";
import { useNotification } from "../NotificationContext";
import ADSearchForm from "./ADSearchForm";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";

const AD_CALENDAR_CACHE_KEY = "adcalendar_state_v1";

const readADCalendarCache = () => {
  try {
    const raw = sessionStorage.getItem(AD_CALENDAR_CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const ADCalendarMain = () => {
  const cached = readADCalendarCache();
  const { showNotification } = useNotification();
  const [selectedVenue, setSelectedVenue] = useState(cached.selectedVenue ?? "");
  const [currentvenue, setCurrentvenue] = useState(cached.currentvenue ?? "");
  const [Courses, setCourses] = useState(Array.isArray(cached.courses) ? cached.courses : []);
  const [venues, setVenues] = useState([]);
  const [calendarDate, setCalendarDate] = useState(
    cached.calendarDate || dayjs().format("YYYY-MM-DD"),
  );
  const [userRole, setUserRole] = useState(null);
  const [icpisname, setIcpisname] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const decodedToken = jwtDecode(token);
      setUserRole(decodedToken.claims.role);
      setIcpisname(decodedToken.claims.icpiename ?? decodedToken.claims.firstname);
    } catch (error) {
      console.error("Invalid token:", error);
    }
  }, []);

  useEffect(() => {
    if (!userRole) return;
    const token = localStorage.getItem("token");
    const authHeader = "Bearer " + token;
    axiosInstance
      .get("/course/coursevenueIdaddress", {
        params: {
          role: userRole,
          icpisname: icpisname ?? "",
        },
        headers: {
          Authorization: authHeader,
        },
      })
      .then((response) => {
        const list = Array.isArray(response.data) ? response.data : [];
        setVenues(list);
        if (selectedVenue) {
          const match = list.find((venue) => venue.id === selectedVenue);
          if (match) {
            setCurrentvenue(match);
          }
        }
      })
      .catch(() => {
        showNotification("Error fetching venues!", "error");
      });
  }, [userRole, icpisname]);

  const handleReset = () => {
    setSelectedVenue("");
    setCurrentvenue(""); // 重置选中的场地
    setCourses([]); // 重置课程数据
    showNotification("Reset successfully!", "success");
  };

  const handleSearch = () => {
    // 检查是否有选择的场地
    if (!currentvenue.id) {
      showNotification("Please select a venue before searching!", "warning");
      return; // 终止搜索，直到选择了场地
    }
    const token = localStorage.getItem("token");
    //("Stored JWT in localStorage:", token);

    const authHeader = "Bearer " + token;
    axiosInstance
      .get("/course/coursecalendar", {
        params: { venueId: currentvenue.id },
        headers: {
          Authorization: authHeader,
        }, // 传递 Bearer token
      })
      .then((response) => {
        if (response.data) {
          //console.log(response.data);
          setCourses(response.data);
          // 保存获取到的课程数据
        } else {
          showNotification("No courses found for this venue!", "warning");
        }
      })
      .catch((error) => {
        console.error("Error in course search:", error);
        showNotification("Error in course search!", "error");
      });
  };

  // 将课程数据映射到 FullCalendar 事件格式
  const calendarEvents = Courses.map((course) => ({
    title: `${course.courseTitle}`, // 显示课程开始时间
    start: `${course.date}T${course.startTime}`, // 合并日期和开始时间
    end: `${course.date}T${course.endTime}`,
    price: `${course.price}`,
    extendedProps: {
      price: `${course.price}`,
      backgroundColor: course.active ? "green" : "red",
    },
  }));

  const renderEventContent = (eventInfo) => {
    return (
      <div
        style={{
          backgroundColor: eventInfo.event.extendedProps.backgroundColor,
          padding: "5px",
          borderRadius: "5px",
          color: "white",
        }}
      >
        <b>{eventInfo.timeText}</b>
        <br />
        <span>{eventInfo.event.title}</span>
        <br />
        <span>Price: ${eventInfo.event.extendedProps.price}</span>
      </div>
    );
  };

  useEffect(() => {
    try {
      sessionStorage.setItem(
        AD_CALENDAR_CACHE_KEY,
        JSON.stringify({
          selectedVenue,
          currentvenue,
          courses: Courses,
          calendarDate,
        }),
      );
    } catch {
      // ignore cache write errors
    }
  }, [selectedVenue, currentvenue, Courses, calendarDate]);

  return (
    <SidebarLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <ADSearchForm
          handleSearch={handleSearch}
          handleReset={handleReset}
          Courses={Courses}
          venues={venues}
          setCurrentvenue={setCurrentvenue}
          selectedVenue={selectedVenue}
          setSelectedVenue={setSelectedVenue}
        />
        {/* FullCalendar 日历显示 */}
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          initialDate={calendarDate}
          events={calendarEvents} // 使用课程数据作为事件
          datesSet={(arg) => {
            const d =
              arg?.view?.currentStart instanceof Date
                ? dayjs(arg.view.currentStart).format("YYYY-MM-DD")
                : dayjs().format("YYYY-MM-DD");
            setCalendarDate(d);
          }}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          eventContent={renderEventContent}
          eventClick={(info) => {
            alert("Course: " + info.event.title);
          }}
          height="auto"
        />
      </Container>
    </SidebarLayout>
  );
};
export default ADCalendarMain;
